import { RefObject, useCallback, useEffect, useState } from 'react';
import { RECALCULATE_SIZE_INTERVAL } from '../constants/size';
import { Size } from '../types/size';

export const useBlockSize = <T extends HTMLElement = HTMLDivElement>(ref: RefObject<T>) => {
	const [size, setSize] = useState<Size>({ height: 0, width: 0 });

	const calculateSize = useCallback(() => {
		if (!ref.current) {
			return;
		}

		const { width, height } = ref.current.getBoundingClientRect();
		setSize({ width, height });
	}, [ref, setSize]);

	useEffect(() => {
		calculateSize();

		window.addEventListener('resize', calculateSize);
		const interval = setInterval(calculateSize, RECALCULATE_SIZE_INTERVAL);

		return () => {
			window.removeEventListener('resize', calculateSize);
			clearInterval(interval);
		};
	}, [calculateSize]);

	return size;
};
